// MUI
import { Button, Typography } from "@mui/material"

// Components
import DotLoading from "src/components/common/dot-loading"

// -------------------------------------------------|| BUTTON - COMPONENTS || ------------------------------------------

const MuiButton = ({
  type = "submit",
  size = "large",
  variant = "contained",
  fullWidth = true,
  loading,
  children,
  sx,
  ...others
}) => {
  return (
    <Button
      type={type}
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      disabled={loading}
      sx={{ ...sx, borderRadius: "8px", mt: 3 }}
      {...others}
    >
      {loading ? (
        <DotLoading sx={{ py: 2 }} color='primary' />
      ) : (
        <Typography fontWeight='bold' py={0.7}>
          {children}
        </Typography>
      )}
    </Button>
  )
}

export default MuiButton
